// JOBE-0044.4: shared relative-time + URN-slug helpers. Promoted from
// LibraryDocumentDetail.jsx so the list row template (JOBE-0044.4) and
// the detail view (JOBE-0044.5) render timestamps the same way.
//
// relTime: short relative string ("2h", "yesterday", "Apr 18"). Falls
// back to the raw input on parse failure so a malformed wire value
// still renders something.

export function relTime(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  if (Number.isNaN(d.getTime())) return ts;
  const now = Date.now();
  const diffMs = now - d.getTime();
  const diffMin = Math.floor(diffMs / 60_000);
  if (diffMin < 1) return 'just now';
  if (diffMin < 60) return `${diffMin}m`;
  const diffHr = Math.floor(diffMin / 60);
  if (diffHr < 24) return `${diffHr}h`;
  const diffDay = Math.floor(diffHr / 24);
  if (diffDay === 1) return 'yesterday';
  if (diffDay < 7) return `${diffDay}d`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

// urnSlug returns the last `:`-separated segment of a URN, used as a
// best-effort display fallback when no `name` is available.
export function urnSlug(u) {
  if (!u || typeof u !== 'string') return '';
  const idx = u.lastIndexOf(':');
  return idx >= 0 ? u.slice(idx + 1) : u;
}
